// eslint-disable-next-line
import { useCallback, useState } from "react";
import { API } from "aws-amplify";
import { useLoginUser } from "../hooks/providers/useLoginUserProvider";
import { useUser } from "../hooks/useUser";

// ダッシュボード
export const useDashboard = () => {
  const { loginUser } = useLoginUser();
  const { refreshToken } = useUser();
  const [ executing, setExecuting ] = useState(false);
  const [ errObj, setErrObj ] = useState(null);
  const [ opeErrMes ] = useState("");
  const [ dashboardUrl, setDashboardUrl ] = useState('');

  const GetDashboard = useCallback(async() => {
    setExecuting(true);

    const apiName = "BackendApi";
    const path = "/dashboard/dashboard_index ";

    const option = {
      headers: {
        'X-NecAuth-Token': await refreshToken()
      },
      queryStringParameters: {
      },
    };
    loginUser.envType === 'DEV' && console.log('getDashboard_param', option);

    (async() => {
      await API.get(apiName, path, option)
      .then(async(res) => {
        loginUser.envType === 'DEV' && console.log("getDashboard_res", res);
        setDashboardUrl(res.dashboard_url);
      })
      .catch((err) => {
        setErrObj(err);
      })
      .finally(() => {
        setExecuting(false);
      });
    })();
  }, []);
  
  return {
    GetDashboard,
    dashboardUrl,
    executing,
    setExecuting,
    errObj,
    opeErrMes,
  };
};
